@if (pedometerIsUsed || locationIsUsed) {
  <div class="diary-sensor-hint-container">
    <div class="icon-container" (click)="setModalIsOpen(true, $event)">
      @if (pedometerIsUsed) {
        <div class="icon-circle">
          <ion-icon slot="icon-only" name="footsteps-sharp"></ion-icon>
          @if (!pedometerPermissionGranted) {
            <div class="cross-out-line"></div>
          }
        </div>
      }

      @if (locationIsUsed) {
        <div class="icon-circle">
          <ion-icon slot="icon-only" name="location-sharp"></ion-icon>
          @if (!locationPermissionGranted) {
            <div class="cross-out-line"></div>
          }
        </div>
      }
    </div>
  </div>

  <ion-modal #modal [isOpen]="modalIsOpen" (willDismiss)="setModalIsOpen(false)" [initialBreakpoint]="0.75" [breakpoints]="[0,0.75,1]">
    <ng-template>
      <ion-content>
        <div class="diary-sensor-info-card">
          <h1>{{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.SENSOR_INFO_TITLE" | translate }}</h1>
          <p>{{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.SENSOR_INFO_DESCRIPTION" | translate }}</p>

          @if (pedometerIsUsed) {
            <div class="sensor-info">
              <div class="sensor-info-title">
                <div class="icon-circle">
                  <ion-icon slot="icon-only" name="footsteps-sharp"></ion-icon>
                  @if (!pedometerPermissionGranted) {
                    <div class="cross-out-line"></div>
                  }
                </div>
                <h4>
                  {{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.SENSOR_INFO_PEDOMETER_TITLE" | translate }}
                  @if (!pedometerPermissionGranted) {
                    <span>({{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.SENSOR_INFO_MISSING_PERMISSION" | translate }})</span>
                  }
                </h4>
              </div>
              <p>{{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.PEDOMETER_DATA_COLLECTION_REASON" | translate }}</p>
            </div>
          }

          @if (locationIsUsed) {
            <div class="sensor-info">
              <div class="sensor-info-title">
                <div class="icon-circle">
                  <ion-icon slot="icon-only" name="location-sharp"></ion-icon>
                  @if (!locationPermissionGranted) {
                    <div class="cross-out-line"></div>
                  }
                </div>
                <h4>
                  {{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.SENSOR_INFO_LOCATION_TITLE" | translate }}
                  @if (!locationPermissionGranted) {
                    <span>({{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.SENSOR_INFO_MISSING_PERMISSION" | translate }})</span>
                  }
                </h4>
              </div>
              <p>{{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.LOCATION_DATA_COLLECTION_REASON" | translate }}</p>
            </div>
          }

          @if (pedometerIsUsed && !pedometerPermissionGranted || locationIsUsed && !locationPermissionGranted) {
            <div class="missing-permission-box">
              <div class="info-icon">
                <ion-icon name="information-circle"></ion-icon>
              </div>
              <p>
                {{ "PERMISSION_ONBOARDING_AND_DIARY_SENSOR_INFO.SENSOR_INFO_MISSING_PERMISSION_ADDITIONAL_INFO" | translate }}
              </p>
            </div>          
          }
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
}